import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, toDisplayString as _toDisplayString, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, resolveDirective as _resolveDirective, withDirectives as _withDirectives, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-ecdc8b84"),n=n(),_popScopeId(),n)
const _hoisted_1 = /*#__PURE__*/_createTextVNode("一覧へ戻る")
const _hoisted_2 = { key: 0 }
const _hoisted_3 = {
  key: 0,
  class: "mt10"
}
const _hoisted_4 = {
  key: 1,
  class: "scroll"
}
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("th", { class: "title-table" }, null, -1))
const _hoisted_6 = { class: "ml20" }
const _hoisted_7 = {
  key: 0,
  class: "color-box"
}
const _hoisted_8 = {
  key: 1,
  class: "color-box-alert"
}
const _hoisted_9 = { key: 2 }

import { useStore } from "vuex";
import { computed, onMounted, ref } from 'vue';
import { useRoute } from "vue-router";
import { AlertFormReport } from "@/types/alert_form_report";
import { AlertFormsRepository } from "@/repositories/AlertFormsRepository";
import { useExceptionMessage } from '@/logic/ExceptionMessageLogic';


export default /*#__PURE__*/_defineComponent({
  setup(__props) {

const route = useRoute();
const store = useStore();
const reportLoading = ref(false);

const limitedDate = ref('');
const params = {limited_at: limitedDate.value};

const repository = new AlertFormsRepository();
const managerFlg = computed(() => store.state.login.manager_flg);
const reports = ref<AlertFormReport>();

onMounted(async (): Promise<void> => {
  reportLoading.value = true;
  if (params.value == undefined) {
    params.value = {limited_at: ""};
  }
  try {
    reports.value = await repository.getFormReport(Number(route.params.alert_form_id), params.value);
    limitedDate.value = reports.value.limited_at_list[0];
    reportLoading.value = false;
  } catch (e: any) {
    useExceptionMessage(e, "エラーが発生しました。<br>再読み込みしてお試しください");
  }
});

const changeDate = async () => {
  params.value.limited_at = limitedDate.value;
  reports.value = await repository.getFormReport(Number(route.params.alert_form_id), params.value);
}

return (_ctx: any,_cache: any) => {
  const _component_el_button = _resolveComponent("el-button")!
  const _component_router_link = _resolveComponent("router-link")!
  const _component_el_option = _resolveComponent("el-option")!
  const _component_el_select = _resolveComponent("el-select")!
  const _component_el_card = _resolveComponent("el-card")!
  const _component_el_main = _resolveComponent("el-main")!
  const _component_el_container = _resolveComponent("el-container")!
  const _directive_loading = _resolveDirective("loading")!

  return (_unref(managerFlg))
    ? (_openBlock(), _createBlock(_component_el_container, { key: 0 }, {
        default: _withCtx(() => [
          _createVNode(_component_el_main, null, {
            default: _withCtx(() => [
              _withDirectives(_createVNode(_component_el_card, { class: "box-card" }, {
                default: _withCtx(() => [
                  _createVNode(_component_router_link, {
                    to: { name: 'AlertForms' },
                    class: "button-link"
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_el_button, { type: "text" }, {
                        default: _withCtx(() => [
                          _hoisted_1
                        ]),
                        _: 1
                      })
                    ]),
                    _: 1
                  }),
                  (reports.value)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
                        _createTextVNode(_toDisplayString(reports.value.alert_form.title) + " ", 1),
                        (reports.value.limited_at_list.length > 0)
                          ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
                              _createVNode(_component_el_select, {
                                modelValue: limitedDate.value,
                                "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((limitedDate).value = $event)),
                                onChange: changeDate
                              }, {
                                default: _withCtx(() => [
                                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(reports.value.limited_at_list, (limited) => {
                                    return (_openBlock(), _createBlock(_component_el_option, {
                                      key: limited,
                                      label: limited,
                                      value: limited
                                    }, null, 8, ["label", "value"]))
                                  }), 128))
                                ]),
                                _: 1
                              }, 8, ["modelValue"])
                            ]))
                          : _createCommentVNode("", true)
                      ]))
                    : _createCommentVNode("", true),
                  (reports.value && reports.value.limited_at_list.length > 0)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_4, [
                        _createElementVNode("table", null, [
                          _createElementVNode("thead", null, [
                            _createElementVNode("tr", null, [
                              _hoisted_5,
                              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(reports.value.projects, (project) => {
                                return (_openBlock(), _createElementBlock("th", { key: project }, [
                                  _createVNode(_component_router_link, {
                                    to: { name: 'ProjectAlertForm', params: { project_id: project.id , project_alert_form_id: project.project_alert_form_id } },
                                    class: "button-link"
                                  }, {
                                    default: _withCtx(() => [
                                      _createTextVNode(_toDisplayString(project.name), 1)
                                    ]),
                                    _: 2
                                  }, 1032, ["to"])
                                ]))
                              }), 128))
                            ])
                          ]),
                          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(reports.value.alert_form.alert_form_items, (alertFormItem) => {
                            return (_openBlock(), _createElementBlock("tbody", {
                              key: alertFormItem.title
                            }, [
                              _createElementVNode("tr", null, _toDisplayString(alertFormItem.title), 1),
                              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(alertFormItem.alert_form_item_fields, (alertFormItemFields) => {
                                return (_openBlock(), _createElementBlock("tr", {
                                  key: alertFormItemFields.title
                                }, [
                                  _createElementVNode("span", _hoisted_6, _toDisplayString(alertFormItemFields.title), 1),
                                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(alertFormItemFields.field_valids, (valids) => {
                                    return (_openBlock(), _createElementBlock("td", { key: valids }, [
                                      valids
                                        ? (_openBlock(), _createElementBlock("div", _hoisted_7))
                                        : _createCommentVNode("", true),
                                      (!valids)
                                        ? (_openBlock(), _createElementBlock("div", _hoisted_8))
                                        : _createCommentVNode("", true)
                                    ]))
                                  }), 128))
                                ]))
                              }), 128))
                            ]))
                          }), 128))
                        ])
                      ]))
                    : (_openBlock(), _createElementBlock("div", _hoisted_9, " まだ表示できるデータがありません。 "))
                ]),
                _: 1
              }, 512), [
                [_directive_loading, reportLoading.value]
              ])
            ]),
            _: 1
          })
        ]),
        _: 1
      }))
    : _createCommentVNode("", true)
}
}

})